import styles from './HorizontalRule.module.scss';

export function HorizontalRule() {
  return <div className={styles.horizontalRule} />;
}
